
import Hero from './components/Hero';
import IndustryGrid from './components/IndustryGrid';
import Framework from './components/Framework';
import WhyPalemia from './components/WhyPalemia';
import Results from './components/Results';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="bg-slate-950">
      <Hero />
      <IndustryGrid />
      <Framework />
      <WhyPalemia />
      <Results />
      <CTA />
      <Footer />
    </div>
  );
}
